import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.dark,
  },

  input: {
    marginRight: theme.spacing(1),
  },
  formHelperText: {
    marginLeft: "0px",
    position: "absolute",
    bottom: "-20px",
  },
}))

export default styles
